import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../utils/helpers/model.helper';

export const DURATION_PER_WEEK_FILTER_SCHEMA = Object.freeze({
  WEEK: 0,
  DURATION: 0,
});
const RECORD = generateSchema(DURATION_PER_WEEK_FILTER_SCHEMA);
const KEYS: any = generateKeys(DURATION_PER_WEEK_FILTER_SCHEMA);

export class DurationPerWeekFilter extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get week(): number {
    return this.get(KEYS.WEEK);
  }

  get duration(): number {
    return this.get(KEYS.DURATION);
  }
}
